import React, { useState } from "react";
import "./PopupCompartilhar.css";

function PopupCompartilhar({ link, onClose }) {
  const [copiado, setCopiado] = useState(false);

  const copiarLink = () => {
    navigator.clipboard.writeText(link);
    alert("Link copiado!");
    setCopiado(true);
    setTimeout(() => setCopiado(false), 1500); // some em 1.5s
  };

  return (
    <div className="popup-compartilhar-overlay">
      <div className="popup-compartilhar">
        <button className="btn-fechar-popup" onClick={onClose}>×</button>

        <h3>COMPARTILHAR PERFIL</h3>

        <div className="popup-linha">
          <img src="https://i.imgur.com/dBtpnpN.png" alt="Ícone de link" className="icone-link" />
          <input type="text" value={link} readOnly />
          <button className="btn copiar" onClick={copiarLink}>Copiar</button>
        </div>

        <div className="popup-redes">
          <a href={`https://x.com/share?url=${encodeURIComponent(link)}`} target="_blank" rel="noopener noreferrer">
            <img src="https://i.imgur.com/KWoSNvY.png" alt="X (Twitter)" />
          </a>
          <a href={`https://wa.me/?text=${encodeURIComponent(link)}`} target="_blank" rel="noopener noreferrer">
            <img src="https://i.imgur.com/vLm8o1I.png" alt="WhatsApp" />
          </a>
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`} target="_blank" rel="noopener noreferrer">
            <img src="https://i.imgur.com/tGdJY2A.png" alt="Facebook" />
          </a>
        </div>
      </div>

      {copiado && <div className="toast-copiado">Link copiado!</div>}
    </div>
  );
}

export default PopupCompartilhar;
